import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  patients: [],
  emails: [],
  totalCount: 0,
  loading: false,
  error: null,
};

const patientSlice = createSlice({
  name: 'patient',
  initialState,
  reducers: {
    setPatients(state, action) {
      state.patients = action.payload.patients || [];
      state.emails = action.payload.emails || [];
      state.totalCount = action.payload.totalCount || 0;
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearPatients(state) {
      state.patients = [];
      state.emails = [];
      state.totalCount = 0;
      state.error = null;
    },
  },
});

export const { setPatients, setLoading, setError, clearPatients } = patientSlice.actions;
export default patientSlice.reducer;
